import { Skeleton, Stack, StackProps, styled } from "@mui/material";

interface LoadingSkeletonProps extends StackProps {
  count?: number;
  variant?: "text" | "rectangular" | "rounded" | "circular";
  height?: number | string;
  width?: number | string;
  spacing?: number;
  direction?: "row" | "column";
  fullWidth?: boolean;
  className?: string;
}

const LoadingSkeleton = ({
  count = 3,
  variant = "text",
  height = 24,
  width = 164,
  spacing = 1,
  direction = "column",
  fullWidth = false,
  className,
  ...props
}: LoadingSkeletonProps) => {
  return (
    <StyledStack
      spacing={spacing}
      direction={direction}
      width={fullWidth ? "100%" : "auto"}
      className={className}
      {...props}
    >
      {[...Array(count)].map((_, i) => (
        <Skeleton
          key={i}
          variant={variant}
          height={height}
          width={fullWidth ? "100%" : width}
          className="loading_box"
        />
      ))}
    </StyledStack>
  );
};

const StyledStack = styled(Stack)({
  "& .loading_box": {
    borderRadius: 4,
  },
});

export default LoadingSkeleton;
